import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;

export default function NumberInput({value, name, placeholder, min, max, onChange}: {
    value: number|string|undefined, name: string, placeholder: string, min?: number, max?: number,
    onChange?: (value?: number)=>any
}){
    const ref:RefObject<HTMLInputElement> = {};
    onChange?.(value?+value:undefined)
    return (
        <input
            name={name}
            placeholder={placeholder}
            type="number"
            min={min}
            max={max}
            className="bordered no-arrows"
            value={value}
            ref={ref}
            maxlength={10}
            onChange={()=>onChange?.(!ref.value!.value || isNaN(+ref.value!.value)?undefined:+ref.value!.value)}
        />
    )
}